import React from 'react'
import styled from 'styled-components'
import { Text } from 'pancakeswap-uikit'

export const ResponsiveText = styled(Text)<{
  mobileFontSize?
  desktopFontSize?
  fontSize?
  mobileWidth?
  desktopWidth?
  width?
}>`
  font-size: ${({ mobileFontSize, fontSize }) => mobileFontSize || fontSize};
  width: ${({ mobileWidth, width }) => mobileWidth || width};

  ${({ theme }) => theme.mediaQueries.sm} {
    font-size: ${({ desktopFontSize, fontSize }) => desktopFontSize || fontSize};
    width: ${({ desktopWidth, width }) => desktopWidth || width};
  }
`

export default ResponsiveText
